import React from 'react'
import { ICharacterItem } from '../../../../../../../../../api/types/character'
import { DeleteIconButton } from '../../../../../../../../../components/DeleteIconButton/DeleteIconButton'
import { mutationDeleteCharacterItem } from '../../../../../../../../../api/mutations'
import { useInvalidatingMutation } from '../../../../../../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { characterInventoryQueryKey } from '../../../../../../../../../api/queries'
import { IDumpItem } from '../../../../../../../../../api/types/item'
import { CharacterItemIdentifyAction } from './CharacterItemIdentifyAction/CharacterItemIdentifyAction'
import { CharacterEquipItem } from './CharacterEquipItem/CharacterEquipItem'
import { CharacterUseItem } from './CharacterUseItem/CharacterUseItem'

export const CharacterItemActions: React.FC<{
  character_item: ICharacterItem
  game_id: number
}> = ({ character_item, game_id }) => {
  const { mutate: handleDumpItem, isLoading: isDumpingItem } = useInvalidatingMutation<
    AxiosResponse,
    IDumpItem
  >(
    dump => mutationDeleteCharacterItem(dump),
    [characterInventoryQueryKey(character_item.character_id)]
  )

  return (
    <>
      <CharacterItemIdentifyAction character_item={character_item} game_id={game_id} />
      <CharacterEquipItem character_item={character_item} game_id={game_id} />
      <CharacterUseItem character_item={character_item} game_id={game_id} />

      <DeleteIconButton
        confirmationBody={
          <div>
            Wyrzucić <span className={'font-weight-bold'}>{character_item.item.name}</span>?
          </div>
        }
        isLoading={isDumpingItem}
        onClick={() =>
          handleDumpItem({
            character_id: character_item.character_id,
            character_item_id: character_item.id,
            game_id: game_id,
          })
        }
      />
    </>
  )
}
